export async function checkWarehouseAccess(to, store) {
  if (store.state.user.restriction_base !== 'Warehouse') return true

  const warehouseId = to.query?.warehouse_id
  if (!warehouseId) return true

  const businessId =
    store.getters['user/getBusinessIdOnRoleWarehouseOperator'](warehouseId) ||
    to.query.business_id

  const channelId = to.params?.id ? +to.params.id : undefined
  const channelCode = to.query?.channel_code

  let allowedMasterIds = []

  try {
    if (businessId && channelId && channelCode) {
      const normalized = await store.dispatch('warehouse/GETWAREHOUSECHANNELLISTV2', {
        business_id: businessId,
        channel_id: channelId,
        channel_code: channelCode,
      })
      allowedMasterIds = Array.isArray(normalized)
        ? normalized.map(i => i.warehouse_master_id)
        : []
    } else {
      const list = store.state.warehouse.warehouseList
      allowedMasterIds = Array.isArray(list)
        ? list.map(i => i.warehouse_master_id || i.id || i.value)
        : []
    }
  } catch (e) {
    return true
  }

  if (!allowedMasterIds.length) return true

  return allowedMasterIds.includes(warehouseId)
}